import { defineComponent as _defineComponent } from 'vue'
import FilterItem from './FilterItem.vue';

interface Props {
  filterItems: Record<string, number>;
  selectedFilters: string[];
  filterKey: string;
  label?: string;
}

interface Emits {
  (event: 'filter:update', filterKey: string, filterLabel: string, e: Event): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FilterList',
  props: {
    filterItems: null,
    selectedFilters: null,
    filterKey: null,
    label: null
  },
  emits: ["filter:update"],
  setup(__props: any) {




return { __sfc: true,FilterItem }
}

})